import { DateTime } from 'luxon';

const soloNumeroRegEx = /^[0-9\b]+$/;
const caractEspeRegEx = /[\s-,.°!<>_"#%&/=@¡*+?^${}()|[\]\\\u00C0-\u017F]+$/;
const validarCorRegEx = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export function validarNumero(texto) {
  return texto === '' || soloNumeroRegEx.test(texto);
}

export function validarCaracteresEspeciales(texto) {
  return caractEspeRegEx.test(texto);
}

export function validarCorreo(texto) {
  return validarCorRegEx.test(texto);
}

export function validateDateFormat(dateString, format) {
  return DateTime.fromFormat(dateString, format).isValid;
}

export function validateAge(dateString, format) {
  const fechaIngresada = DateTime.fromFormat(dateString, format);
  const fechaActual = DateTime.local();
  const diferencia = fechaActual.diff(fechaIngresada, 'years').years;
  return Math.floor(diferencia);
}

export function formatAmount(number, blur) {
  if (number === '') return '';

  if (number.indexOf('.') >= 0) {
    let numberParts = number.split('.');
    let entero = numberParts[0];
    entero = formatNumber(entero);
    number = entero;
  } else {
    number = formatNumber(number);
  }
  return number;
}

export function removeFormatNumber(number) {
  return number.replace(/,/g, '');
}

function formatNumber(n) {
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function obtenerFechaActual() {
  return DateTime.local().toFormat('dd/MM/yyyy');
}

export function capitalizarPalabras(texto) {
  return texto
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function obtenerFechaNacimiento(dateString) {
  let dt = dateString.split('/').reverse().join('/');
  const fechNacimiento = dt.replace(/\//g, '');
  return fechNacimiento;
}
